module.exports = __webpack_public_path__ + "static/media/img_cal14.18a185d5.jpg";